module.exports = __webpack_public_path__ + "static/BOA.5d0b0d12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BOA.svg
// module id = 428
// module chunks = 35783957827783